import { render, staticRenderFns } from "./xcxindex.vue?vue&type=template&id=46f6872a&scoped=true&"
import script from "./xcxindex.vue?vue&type=script&lang=js&"
export * from "./xcxindex.vue?vue&type=script&lang=js&"
import style0 from "./xcxindex.vue?vue&type=style&index=0&id=46f6872a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6872a",
  null
  
)

component.options.__file = "xcxindex.vue"
export default component.exports